export default class ButtonAudioPlayer {
  constructor() {
    this.selector = ".button--audio-player";
  }

  bootstrap() {
    $(document).on("click", this.selector, function (e) {
      e.preventDefault();

      const btn = e.currentTarget;
      btn.classList.add("active");

      const wrapper = btn.nextElementSibling;
      const currentAudio = wrapper && wrapper.querySelector("audio");

      if (!currentAudio) {
        return;
      }

      currentAudio.play();
    });

    document.addEventListener("play", function (event) {
      const currentAudio = event.target;

      document.querySelectorAll("audio").forEach(audio => {
        if (audio !== currentAudio) {
          audio.pause();
        }
      });
    }, true);
  }
}
